import { render, staticRenderFns } from "./ChangeMandateDates.vue?vue&type=template&id=ecb5b93c&"
import script from "./ChangeMandateDates.vue?vue&type=script&lang=js&"
export * from "./ChangeMandateDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports